import {
  GET_MANAGER_INVITE_REQUEST,
  GET_MANAGER_INVITE_REQUEST_FAILED,
  GET_MANAGER_INVITE_REQUEST_SUCCEEDED
} from "../constants/invites";

export const invites = (
  state = {
    isFetching: false,
    data: {},
    error: {}
  }, action) => {
  let newState = {...state};

  switch (action.type) {
    case GET_MANAGER_INVITE_REQUEST:
      newState.isFetching = true;
      return newState;

    case GET_MANAGER_INVITE_REQUEST_SUCCEEDED:
      newState.isFetching = false;
      newState.data = action.data;
      newState.error = {};
      return newState;

    case GET_MANAGER_INVITE_REQUEST_FAILED:
      newState.isFetching = false;
      newState.error = action.error;
      newState.data = [];
      return newState;

    default:
      return newState;
  }
};
